import AlbumSlideshowShareModal, { ALBUM_SLIDESHOW_SHARE_MODAL } from './modal';

export { ALBUM_SLIDESHOW_SHARE_MODAL };

export default AlbumSlideshowShareModal;
